import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

interface LinearBufferLoaderProps {
  showLoader: boolean;
  fileName: string;
}

const FileUploadProgressLoader: React.FC<LinearBufferLoaderProps> = ({ showLoader, fileName }) => {
  const [progress, setProgress] = React.useState(0);
  const [buffer, setBuffer] = React.useState(10);

  const progressRef = React.useRef(() => {});

  React.useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        setProgress(0);
        setBuffer(10);
      } else {
        const diff = Math.random() * 10;
        const diff2 = Math.random() * 10;
        setProgress(progress + diff);
        setBuffer(progress + diff + diff2);
      }
    };
  });

  React.useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (showLoader) {
      timer = setInterval(() => {
        progressRef.current();
      }, 500);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [showLoader]);

  const truncatedFileName =
    fileName.length > 30 ? `${fileName.slice(0, 30)}...` : fileName;

  return showLoader ? (
    <Box sx={{ width: '95%', display: 'flex', alignItems: 'center', flexDirection: 'column', marginTop: '20px', backgroundColor: '#343434', paddingTop:'10px', paddingBottom: '10px', borderRadius:'5px', margin:'auto' }}>
      <Box sx={{ width: '90%', mr: 1, marginBottom: '10px' }}>
        <LinearProgress variant="buffer" value={progress} valueBuffer={buffer} />
      </Box>
      <Typography variant="body2" color="white">
        <b>Uploading: </b>
        {truncatedFileName}
      </Typography>
    </Box>
  ) : null;
};

export default FileUploadProgressLoader;